import React, { useState, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import { fetchBookmarked, createBookmarked, deleteBookmarked } from '../../../services/scouts';

type Props = {
  personId: number;
};

export const Component: FunctionComponent<Props> = ({
  personId,
}) => {
  const [isBookmarked, setIsBookmarked] = useState(false);

  const getBookmarked = async () => {
    try {
      const response = await fetchBookmarked(personId);
      setIsBookmarked(response.isBookmarked);
    } catch (error) {
      console.log(error)
    }
  };

  const createBookmark = async () => {
    try {
      await createBookmarked(personId);
      getBookmarked();
    } catch (error) {
      console.log(error);
    }
  };

  const deleteBookmark = async () => {
    try {
      await deleteBookmarked(personId);
      getBookmarked();
    } catch (error) {
      console.log(error);
    }
  };

  return <Presentation isBookmarked={isBookmarked} onCreateBookmark={createBookmark} onDeleteBookmark={deleteBookmark} />;
};
